// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAuthorizedUserDto
 */
export interface IAuthorizedUserDto {
    /**
     * 
     * @type {number}
     * @memberof IAuthorizedUserDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAuthorizedUserDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAuthorizedUserDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthorizedUserDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuthorizedUserDto
     */
    relationship_type?: IAuthorizedUserDtoRelationshipTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IAuthorizedUserDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IAuthorizedUserDto
     */
    status?: IAuthorizedUserDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IAuthorizedUserDto
     */
    created_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IAuthorizedUserDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}
/**
* @export
* @enum {string}
*/
export enum IAuthorizedUserDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}


/**
 * Check if a given object implements the IAuthorizedUserDto interface.
 */
export function instanceOfIAuthorizedUserDto(value: object): value is IAuthorizedUserDto {
    return true;
}

export function IAuthorizedUserDtoFromJSON(json: any): IAuthorizedUserDto {
    return IAuthorizedUserDtoFromJSONTyped(json, false);
}

export function IAuthorizedUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAuthorizedUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'status': json['status'] == null ? undefined : json['status'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IAuthorizedUserDtoToJSON(json: any): IAuthorizedUserDto {
    return IAuthorizedUserDtoToJSONTyped(json, false);
}

export function IAuthorizedUserDtoToJSONTyped(value?: IAuthorizedUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'employee_id': value['employee_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'relationship_type': value['relationship_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'status': value['status'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

